import React, { useEffect, useMemo } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import Document from "@tiptap/extension-document";
import StarterKit from "@tiptap/starter-kit";
import { Button, Space, Tooltip } from "antd";
import { BoldOutlined, OrderedListOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HistoryPhraseSuggestion } from "./client-history-phrase-suggestion";
import { HistorySection } from "./client-history-section-node";
import { editorToSections, sectionsToEditorDoc } from "./client-history-doc";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";

const HistoryDocument = Document.extend({
  content: "historySection+"
});

/**
 * WYSIWYG: фиксированные названия разделов + редактируемое тело каждого.
 * onChange отдаёт массив { idPart, value } по каждому разделу.
 */
const ClientHistoryEditor = ({ sections, onChange, editable = true }) => {
  const initialDoc = useMemo(() => sectionsToEditorDoc(sections), [sections]);

  const editor = useEditor({
    immediatelyRender: false,
    editable,
    extensions: [
      HistoryDocument,
      StarterKit.configure({
        document: false,
        heading: false,
        codeBlock: false,
        code: false,
        blockquote: false,
        horizontalRule: false
      }),
      HistorySection,
      HistoryPhraseSuggestion
    ],
    content: initialDoc,
    editorProps: {
      attributes: {
        class: "client-history-wysiwyg__content"
      }
    },
    onUpdate: ({ editor: ed }) => {
      onChange?.(editorToSections(ed));
    }
  });

  useEffect(() => {
    if (editor) editor.setEditable(editable);
  }, [editor, editable]);

  if (!editor) return null;

  const insertPhraseTrigger = () => {
    editor.chain().focus().insertContent("/").run();
  };

  return (
    <div className="client-history-wysiwyg">
      <div className="client-history-wysiwyg__bar">
        <Space size={4} wrap>
          <Tooltip title="Жирный">
            <Button
              size="small"
              type={editor.isActive("bold") ? "primary" : "default"}
              icon={<BoldOutlined />}
              onClick={() => editor.chain().focus().toggleBold().run()}
            />
          </Tooltip>
          <Tooltip title="Маркированный список">
            <Button
              size="small"
              type={editor.isActive("bulletList") ? "primary" : "default"}
              icon={<UnorderedListOutlined />}
              onClick={() => editor.chain().focus().toggleBulletList().run()}
            />
          </Tooltip>
          <Tooltip title="Нумерованный список">
            <Button
              size="small"
              type={editor.isActive("orderedList") ? "primary" : "default"}
              icon={<OrderedListOutlined />}
              onClick={() => editor.chain().focus().toggleOrderedList().run()}
            />
          </Tooltip>
          <Tooltip title="Список фраз (/)">
            <Button size="small" onClick={insertPhraseTrigger}>
              Фраза
            </Button>
          </Tooltip>
        </Space>
      </div>
      <EditorContent editor={editor} className="client-history-wysiwyg__surface" />
    </div>
  );
};

export default ClientHistoryEditor;
